import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tutvu teiste kaubamärgi <span style="color:#a6d189;">**{brand}**</span> toodetega

  <span style="color:#85c1dc;">**FI:**</span>
  Tutustu muihin <span style="color:#a6d189;">**{brand}**</span>-tuotteisiin

  <span style="color:#85c1dc;">**RU:**</span>
  Ознакомьтесь с другими товарами марки <span style="color:#a6d189;">**{brand}**</span>
*/
/* @__NO_SIDE_EFFECTS__ */
const m947 = msg(
  mf`Tutvu teiste kaubamärgi ${'brand'} toodetega`,
  mf`Tutustu muihin ${'brand'}-tuotteisiin`,
  mf`Ознакомьтесь с другими товарами марки ${'brand'}`,
)

export { m947 as 'w.module.product_description.brand' }